import { Stack, Box } from '@mui/material'
import { useSelector } from 'react-redux'
import ContentRatings from './ContentRatings'
import Genres from './Genres'

export default function Filter(props) {
    const genres = useSelector((state, action) => state.filters.genres)

    return (
        <div className="filter">
            <Stack justifyContent='space-around' alignItems='center'>
                <Genres />
                <ContentRatings />
            </Stack>
        </div>
    )
}